import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import OkSwitch from "shared/components/oknf/OkSwitch";
import Textarea from "react-textarea-autosize";
import Str from "shared/components/Str";

import Answers from "apps/questions/components/Answers";
import AcceptedAnswers from "apps/questions/components/AcceptedAnswers";
import Importance from "apps/questions/components/Importance/";
import PrivateIcon from "apps/questions/components/PrivateIcon";

import { areAllAccepted } from "apps/questions/util/helpers";

import "./index.scss";

if (process.env.PLATFORM === "desktop") {
	require("./index.desktop.scss");
} else {
	require("./index.mobile.scss");
}

class MultiPartQuestion extends Component {
	componentDidMount() {
		this.props.onDisplayQuestion();
	}

	render() {
		const {
			isLoading,
			question,
			answers,
			importance,
			lastImportance,
			explanation,
			isPrivate,
			cantReanswer,
			onSelectAnswer,
			onToggleAcceptedAnswer,
			onSetImportance,
			onTogglePrivacy,
			onChangeExplanation,
		} = this.props;

		const allAccepted = areAllAccepted(answers);
		const disabled = isLoading || cantReanswer;

		return (
			<div className="questionspage-multipartquestion oknf oknf--gray">
				{question !== "" &&
					<h1 className="questionspage-multipartquestion-questiontext">
						{question}
					</h1>
				}

				{cantReanswer &&
					<Str className="questionspage-multipartquestion-error">
						You answered that question too recently; try again tomorrow!
					</Str>
				}

				{question === "" &&
					<span>
						<div className="questionspage-multipartquestion-questiontext-placeholder" />
						<div className="questionspage-multipartquestion-questiontext-placeholder" />
					</span>
				}

				<Str className="questionspage-multipartquestion-label">
					Your answer
				</Str>
				<Answers
					answers={answers.map((answer) => answer.text)}
					currentAnswer={answers.map((answer) => answer.isSelected).indexOf(true)}
					onChangeAnswer={onSelectAnswer}
					disabled={disabled}
				/>

				<Str className="questionspage-multipartquestion-label">
					Answers you’ll accept
				</Str>
				<AcceptedAnswers
					answers={answers.map((answer) => answer.text)}
					currentAcceptedAnswers={
						answers.map((answer, i) => i).filter((i) => answers[i].isAccepted)
					}
					onChangeAcceptedAnswers={onToggleAcceptedAnswer}
					disabled={disabled}
				/>

				<Importance
					importance={importance}
					lastImportance={lastImportance}
					allAccepted={allAccepted}
					onChange={onSetImportance}
					disabled={disabled}
				/>

				<Textarea
					className="questionspage-multipartquestion-explanation oknf-textarea"
					placeholder="Explain your answer (optional)"
					maxRows={5}
					value={explanation}
					onChange={(e) => {
						onChangeExplanation(e.currentTarget.value);
					}}
					disabled={disabled}
				/>

				<OkSwitch
					className="questionspage-multipartquestion-privacy"
					label={<Fragment>
						<PrivateIcon />
						<Str>Answer privately</Str>
					</Fragment>}
					checked={isPrivate}
					onChange={onTogglePrivacy}
					disabled={disabled}
				/>

				<Str className="questionspage-multipartquestion-privacy-explanation">
					Questions answered privately are used for match score but hidden from
					your profile
				</Str>
			</div>
		);
	}
}

MultiPartQuestion.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	question: PropTypes.string.isRequired,
	answers: PropTypes.arrayOf(PropTypes.shape({
		text: PropTypes.string.isRequired,
		isSelected: PropTypes.bool,
		isAccepted: PropTypes.bool,
	})).isRequired,
	importance: PropTypes.string,
	lastImportance: PropTypes.string,
	isPrivate: PropTypes.bool.isRequired,
	cantReanswer: PropTypes.bool.isRequired,
	explanation: PropTypes.string,
	onSelectAnswer: PropTypes.func.isRequired,
	onDisplayQuestion: PropTypes.func.isRequired,
	onToggleAcceptedAnswer: PropTypes.func.isRequired,
	onSetImportance: PropTypes.func.isRequired,
	onTogglePrivacy: PropTypes.func.isRequired,
	onChangeExplanation: PropTypes.func.isRequired,
};

MultiPartQuestion.defaultProps = {
	importance: null,
	lastImportance: null,
};

export default MultiPartQuestion;



// WEBPACK FOOTER //
// ./src/apps/questions/components/MultiPartQuestion/index.jsx